(ns dre.pages.admin.feed.events
  (:require
   [clojure.string :as str]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.network :as-alias network]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path [:pages :data :admin-feed])

; vvv EVENTS vvv

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ _]
  {::network/request [{:endpoint :admin/feeds}
                      {:response-content-type :json
                       :on-success [::init-ok]
                       :on-failure [::init-nok]}]}))

(rf/reg-event-db
 ::init-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [{::fetch-fx/keys [response]}]]
  (assoc db :feeds {:state :success
                    :data (:body response)})))

(rf/reg-event-db
 ::init-nok
 [(rf/path db-path)]
 (fn-traced
  [{db :db} _]
  (assoc-in db [:feeds :state] :failure)))

(rf/reg-event-db
 ::search-text-on-change
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [text]]
  (assoc db :search-text text)))

(rf/reg-event-fx
 ::toggle-feed
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [id] :as opts}]]
  {:db (assoc-in db [:feeds :state] :updating)
   ::network/request [{:endpoint :admin/feeds.toggle
                       :context {:id id}}
                      {:response-content-type :json
                       :on-success [::toggle-feed-ok opts]
                       :on-failure [::toggle-feed-nok opts]}]}))

(rf/reg-event-fx
 ::toggle-feed-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response] :as opts}]]
  (if (not= [1] (:body response))
    {:fx [[:dispatch [::toggle-feed-nok opts]]]}
    {:db (-> db
             (update-in [:feeds :data]
                        #(mapv (fn [feed]
                                 (let [uf (fn [x] (if (= 1 x) 0 1))]
                                   (if (= (:source-id feed)
                                          (:id opts))
                                     (update feed :feed-status uf)
                                     feed)))
                               %))
             (assoc-in [:feeds :state] :success))})))

(rf/reg-event-fx
 ::toggle-feed-nok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [opts]]
  {:db (assoc-in db [:feeds :state] :failure)
   :dispatch [::network/default-failure opts]}))

(rf/reg-event-db
 ::delete-feed
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [id]]
  (update-in db [:feeds :data]
             #(filterv (fn [{:keys [source-id]}]
                         (not= id source-id))
                       %))))

(rf/reg-event-db
 ::add-new-feed
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [feed]]
  (println "feed is:" feed)
  (update-in db [:feeds :data] conj feed)))

; vvv SUBS vvv

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db db-path)))

(rf/reg-sub
 ::search-text
 :<- [::state]
 (fn [state _]
   (:search-text state)))

(rf/reg-sub
 ::feeds
 :<- [::state]
 (fn [state]
   (:feeds state)))

(defn- by-search-text
  [search-text feed]
  (let [searchable-keys [:link :title :category :created :changed]
        searchable-values (->> ((apply juxt searchable-keys) feed)
                               (keep identity)
                               (map str/lower-case))]
    (some #(str/includes? % (str/lower-case (or search-text ""))) searchable-values)))

(rf/reg-sub
 ::-feeds-data
 :<- [::feeds]
 (fn [feeds]
   (:data feeds)))

(rf/reg-sub
 ::feeds-data
 :<- [::-feeds-data]
 :<- [::search-text]
 (fn [[feeds search-text] _]
   (if (empty? search-text)
     feeds
     (filter #(by-search-text search-text %) feeds))))

(rf/reg-sub
 ::feeds-loading?
 :<- [::feeds]
 (fn [feeds _]
   (= :loading (:state feeds))))

(rf/reg-sub
 ::feeds-updating?
 :<- [::feeds]
 (fn [feeds _]
   (= :updating (:state feeds))))
